var map = {
	"./default_captcha0.jpg": "./assets/images/captcha/default_captcha0.jpg",
	"./default_captcha1.jpg": "./assets/images/captcha/default_captcha1.jpg",
	"./default_captcha2.jpg": "./assets/images/captcha/default_captcha2.jpg",
	"./default_captcha3.jpg": "./assets/images/captcha/default_captcha3.jpg",
	"./default_captcha4.jpg": "./assets/images/captcha/default_captcha4.jpg",
	"./default_captcha5.jpg": "./assets/images/captcha/default_captcha5.jpg",
	"./default_captcha6.jpg": "./assets/images/captcha/default_captcha6.jpg",
	"./default_captcha7.jpg": "./assets/images/captcha/default_captcha7.jpg",
	"./default_captcha8.jpg": "./assets/images/captcha/default_captcha8.jpg",
	"./default_captcha9.jpg": "./assets/images/captcha/default_captcha9.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/captcha sync recursive ^\\.\\/default_captcha.*\\.jpg$";